<script setup>
import { ldJson } from '@/lib/jsonLd';
import { Head, Link } from '@inertiajs/vue3';

defineProps({
    domain: { type: Object, default: null },
    regions: { type: Array, default: () => [] },
    seoTitle: String,
    metaDescription: String,
    canonicalUrl: String,
    jsonLd: { type: [Object, Array], default: null },
});
</script>

<template>
    <Head :title="seoTitle">
        <meta name="description" :content="metaDescription || ''" />
        <component :is="'script'" v-if="jsonLd" type="application/ld+json" v-html="ldJson(jsonLd)" />
    </Head>

    <main class="standorte-index">
        <header class="standorte-index__header">
            <p class="standorte-index__eyebrow">Standorte</p>
            <h1>Regionale Übersicht - Wärmepumpe und Photovoltaik</h1>
            <p class="standorte-index__intro">
                Jede Region mit eigenem Standortverzeichnis: alle Städte, Stadtteile und Umlandgemeinden
                mit bis zu drei Angeboten regionaler Fachbetriebe.
            </p>
        </header>

        <section class="standorte-index__grid">
            <Link
                v-for="r in regions"
                :key="r.slug"
                :href="`/standorte/${r.slug}`"
                class="standorte-index__card"
            >
                <h2>{{ r.name }}</h2>
                <p class="standorte-index__count">{{ r.count }} Standorte</p>
                <p v-if="r.intro" class="standorte-index__brief">{{ r.intro }}</p>
                <span class="standorte-index__cta">Region öffnen &rarr;</span>
            </Link>
        </section>
    </main>
</template>

<style scoped>
.standorte-index {
    max-width: 1100px;
    margin: 0 auto;
    padding: 40px 24px 80px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
    color: #0f172a;
}
.standorte-index__eyebrow {
    text-transform: uppercase;
    letter-spacing: 0.12em;
    font-size: 12px;
    color: #64748b;
    margin: 0 0 12px;
}
.standorte-index__header h1 {
    font-size: 32px;
    line-height: 1.2;
    margin: 0 0 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
}
.standorte-index__intro {
    font-size: 16px;
    line-height: 1.65;
    color: #334155;
    max-width: 760px;
    margin: 0 0 40px;
}
.standorte-index__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
}
.standorte-index__card {
    display: flex;
    flex-direction: column;
    gap: 8px;
    border: 1px solid #e2e8f0;
    border-radius: 12px;
    padding: 24px;
    background: #ffffff;
    color: inherit;
    text-decoration: none;
    transition: border-color 0.15s ease, transform 0.15s ease;
}
.standorte-index__card:hover {
    border-color: #fb923c;
    transform: translateY(-1px);
}
.standorte-index__card h2 {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
}
.standorte-index__count {
    margin: 0;
    font-size: 13px;
    color: #ea580c;
    font-weight: 600;
    letter-spacing: 0.02em;
}
.standorte-index__brief {
    margin: 6px 0 0;
    font-size: 13px;
    line-height: 1.55;
    color: #64748b;
}
.standorte-index__cta {
    margin-top: auto;
    padding-top: 12px;
    font-size: 13px;
    color: #ea580c;
    font-weight: 500;
}
</style>
